"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startApp = startApp;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _q = _interopRequireDefault(require("q"));

var _handlers = require("q/js/handlers");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRouter = require("react-router");

var _reactRouterRedux = require("react-router-redux");

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _NotificationMiddleware = _interopRequireDefault(require("ReduxMessenger/middleware/NotificationMiddleware"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _Browsers = require("lead-flows-ui/utils/Browsers");

var _Gates = require("lead-flows-ui/actions/Gates");

var _Portal = require("lead-flows-ui/actions/Portal");

var _Scopes = require("lead-flows-ui/actions/Scopes");

var _User = require("lead-flows-ui/actions/User");

var _LeadFlowsRouter = _interopRequireDefault(require("lead-flows-ui/LeadFlowsRouter"));

var _Logger = _interopRequireDefault(require("lead-flows-ui/lib/Logger"));

var _RootReducer = _interopRequireDefault(require("lead-flows-ui/reducers/RootReducer"));

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var _hubspotPluginCommon = require("hubspot-plugin-common");

// Make sure thee test utils are included in the bundle for the sake of Integrate.
function createReduxStore() {
  return (0, _redux.createStore)(_RootReducer.default, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk.default, (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory), _NotificationMiddleware.default), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
    return f;
  }));
}

function createHistory(store) {
  return (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store, {
    selectLocationState: function selectLocationState(state) {
      return state.router;
    }
  });
}

function handleGateData(gates, store) {
  store.dispatch((0, _Gates.handleSetGates)(gates));
}

function handleUserData(user, store) {
  store.dispatch((0, _Scopes.setScopes)(user.scopes));
  store.dispatch((0, _User.setUser)(user));
}

function handlePortalData(portal, store) {
  store.dispatch((0, _Portal.setPortalData)(portal));
}

function getUserInfo(store) {
  return _q.default.Promise.all([(0, _userInfo.default)(), _I18n.default.Info]).then(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
        _ref2$ = _ref2[0],
        gates = _ref2$.gates,
        user = _ref2$.user,
        portal = _ref2$.portal;

    handleUserData(user, store);
    handleGateData(gates, store);
    handlePortalData(portal, store);
    return {
      gates: gates,
      user: user
    };
  }, function (error) {
    LOG.error(error);
  });
}

function bootstrap() {
  var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : createReduxStore();
  window.LOG = new _Logger.default(); // Set up PortalId global vars for hub-http.

  _hubspot.default.get();

  var history = createHistory(store);
  (0, _handlers.logQPromiseIssuesAndSendAlerts)();
  var userInfoPromise = getUserInfo(store).then(function () {
    var rootElement = document.getElementById('lead-flows-app'); // Horrible Safari hack, but it doesn't seem to be a good
    // way to deal with scroll in flex components in that browser

    if ((0, _Browsers.isSafari)()) {
      rootElement.style.display = 'table';
      rootElement.style.height = '100vh';
    }

    _reactDom.default.render(_react.default.createElement(_reactRedux.Provider, {
      store: store
    }, _react.default.createElement(_LeadFlowsRouter.default, {
      history: history
    })), rootElement);
  }).done();
  (0, _hubspotPluginCommon.initWordPress)(window.Raven, history, _eventsTrackerUtils.tracker, userInfoPromise);
}

function startApp() {
  try {
    bootstrap();
  } catch (error) {
    LOG.error(error);
  }
}